export default __webpack_public_path__ + "static/media/Adobe-Logo.580ab844.svg";